<script lang="ts" setup>
import { defineComponent, ref } from "vue";
import Pagination from "@/components/Common/Pagination.vue";
import { useItemStore } from "@/stores/management/item";
import ProductsFilter from "@/components/Pages/Management/Catalog/ProductsFilter.vue";
import router from "@/router";

const itemStore = useItemStore();
const listCatalogs = ref<any>();
const page = ref(1);
const limit = ref(12);
const totalItem = ref(0);

const loadListProduct = async (query = "") => {
  const { success, message } = await itemStore.dispatchGetCatalogs(
    page.value,
    limit.value,
    query
  );
  if (success) {
    listCatalogs.value = await itemStore.items.items;
    totalItem.value = await itemStore.items.total;
  }
};

const updatePage = (data: any) => {
  page.value = data;
  loadListProduct();
};

loadListProduct();

const toDetailProduct = (id = 0) => {
  router.push("/management/catalog/detail/" + id);
};
</script>
<template>
  <ProductsFilter @searchByQuery="loadListProduct" />
  <div v-if="totalItem > 0">
    <div class="section-catalog">
      <div class="row justify-content-center">
        <div
          class="col-lg-3 col-sm-6 mb-4"
          v-for="product in listCatalogs"
          :key="product.id"
        >
          <div class="card card-catalog">
            <div class="mb-4 transition-y card-body">
              <div class="position-relative mb-3">
                <div class="image-box">
                  <img
                    :src="product.image_link"
                    class="rounded-3"
                    alt="product"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-12 fs-15 mb-0">
                  MSG CODE :
                  <span class="fw-medium">{{ product.msg_code }}</span>
                </div>
                <div class="col-12 fs-15 mb-0">
                  IMPA CODE :
                  <span class="fw-medium">{{ product.impa_code }}</span>
                </div>
                <div class="col-12 fs-15 mb-0">
                  Category :
                  <span class="fw-medium">{{ product.category_name }}</span>
                </div>
                <div class="col-12 fs-15 mb-0">
                  Group Category :
                  <span class="fw-medium">{{
                    product.group_category_name
                  }}</span>
                </div>
                <div class="col-12 fs-15 mb-0">
                  Item :
                  <span class="fw-bold">{{ product.name }}</span>
                </div>
                <!-- <div class="col-12 fs-15 mb-0">
                  Unit :
                  <span class="fw-medium">{{ product.unit_type_name }}</span>
                </div>
                <div class="col-12 fs-15 mb-0">
                  Size :
                  <span class="fw-medium">{{ product.size }}</span>
                </div> -->
                <div class="col-12 fs-15 mt-4 text-center">
                  <button
                    class="btn btn-primary btn-sm text-white"
                    @click="toDetailProduct(product?.id)"
                  >
                    View
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-12">
          <div class="card bg-white border-0 rounded-3 mb-4">
            <div class="card-body p-4">
              <Pagination
                @page-change="updatePage"
                :items="limit"
                :total="totalItem"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="card bg-white">
      <div class="transition-y card-body p-5">
        <div
          class="card-content d-flex justify-content-center align-items-center empty-state"
        >
          <div class="fs-2">Data Not Found</div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.empty-state {
  min-height: 200px;
}
.card-catalog {
  min-height: 600px;
  background-color: #fff !important;
}
.section-catalog {
  min-height: 500px;
}
.image-box {
  min-height: 310px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
